module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_8_m2.6b975fb8c63268bca3e756617c17ec06.png";